import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
} from "@mui/material";
import React, { FC } from "react";

const BasicTable: FC<{
  titles: string[];
  loader: boolean;
  renderTableItems: JSX.Element[];
}> = ({ titles, loader, renderTableItems }) => {
  return (
    <Table aria-label="simple table" style={{ margin: "0.4em 0" }}>
      <TableHead>
        <TableRow>
          {titles.map((item) => (
            <TableCell>{item}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody
        sx={{
          position: "relative",
          width: `${loader ? "500px" : "100%"}`,
          height: `${loader ? "300px" : "100%"}`,
        }}
      >
        {loader ? (
          <CircularProgress
            color="primary"
            sx={{
              marginTop: 1,
              position: "absolute",
              right: "50%",
              top: "50%",
            }}
          />
        ) : (
          renderTableItems
        )}
      </TableBody>
    </Table>
  );
};

export default BasicTable;
